require('./bootstrap');
import 'lazysizes';

// POLYFILL

if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (var i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}
if (!Object.entries) {
   Object.entries = function( obj ){
      var ownProps = Object.keys( obj ),
         i = ownProps.length,
         resArray = new Array(i); // preallocate the Array

      while (i--)
         resArray[i] = [ownProps[i], obj[ownProps[i]]];
      return resArray;
   };
}   

   
   
$(document).ready(function() {
  AOS.init();
  /* INCLUDE SVG */
  $('img[data-src$=".svg"]').each(function() {
      var $img = jQuery(this);
      var imgURL = $img.attr('data-src');
      var attributes = $img.prop("attributes");

      $.get(imgURL, function(data) {
          // Get the SVG tag, ignore the rest
          var $svg = jQuery(data).find('svg');

          // Remove any invalid XML tags
          $svg = $svg.removeAttr('xmlns:a');

          // Loop through IMG attributes and apply on SVG
          $.each(attributes, function() {
              $svg.attr(this.name, this.value);
          });

          // Replace IMG with SVG
          $img.replaceWith($svg);
      }, 'xml');
  });
  
  /* LOTTIE ANIMATIONS*/
  document.querySelectorAll('.animation').forEach(function(item, index) {
        
      item.dataset.lottieId = index;
      
      var anime = lottie.loadAnimation({
          container: document.querySelector('.animation[data-lottie-id="' + index + '"]'), // the dom element that will contain the animation
          renderer: 'svg',
          loop: true,
          autoplay: false,
          name: 'AnimationId' + index,
          path: '/img/' + item.dataset.animation + '.json' // the path to the animation json
      });
      
      item.addEventListener('mouseenter', function(e) {
          //console.log(e.target.querySelector('.lottie-container'))
          anime.play('AnimationId' + index)
      });
      item.addEventListener('mouseleave', function(e) {
          //console.log(e.target.querySelector('.lottie-container'))
          anime.stop('AnimationId' + index)
      });
  })

  // The referral booklet trigger opens a modal immediately. Remove the temporary
  // native focus ring that some browsers display on the trigger during this transition.
  document.querySelectorAll('.patch[data-target="#livretParrainageModal"]').forEach(function(item) {
      item.addEventListener('mousedown', function(event) {
          event.preventDefault();
      });

      item.addEventListener('click', function() {
          this.blur();
      });
  });

  // Bootstrap restores focus to the modal trigger when it closes. That restoration
  // produces a visible focus ring on the decorative referral patch.
  $('#livretParrainageModal').on('hidden.bs.modal', function() {
      window.setTimeout(function() {
          document.querySelectorAll('.patch[data-target="#livretParrainageModal"]').forEach(function(item) {
              item.blur();
          });
      }, 0);
  });
  
  // NAV TOGGLE
  $('#toggle, .overlay-menu .nav-link').click(function() {
    $('#toggle').toggleClass('active');
    $('#overlay').toggleClass('open');
    if(window.innerWidth < 992 ) {
      $('#main-nav').toggleClass(' backdrop');
      $('body').toggleClass(' modal-open');
      
    }
  });
  
  // NAV TOGGLE DROPDOWN
  $('#groupe-arc-subnav').hover(function() {
      $(this).find('.dropdown-toggle').dropdown('toggle');
    }, function() {
      $(this).find('.dropdown-toggle').dropdown('toggle');
  })
  
  // NAV SHADOW
  $(window).scroll(function(){
      var posScroll = $(document).scrollTop();
      if(posScroll >=5) {
        $('#main-nav').addClass('boxshadow');
        $('#sub-nav').addClass('boxshadow');
      }
      else {
        $('#main-nav').removeClass('boxshadow');
        $('#sub-nav').removeClass('boxshadow');
      }
  });
  
  
  /* RESIZE EVENT */
  window.reportWindowSize = function () {
    // ADD CONFIG FOR MAIN MENU ON SMALL SCREENS
    if(window.innerWidth <= 992) {
        $( ".header-nav" ).addClass( "nav-mobile" );
    } else {
        $( ".header-nav" ).removeClass( "nav-mobile" );
    }
  }
  
  reportWindowSize();
  
  window.addEventListener('resize', function() {
      reportWindowSize();
  });
  
  
  
  /// SCROLLto  
  $('.js-scrollTo').on('click', function() { 
        var page = $(this).attr('href'); 
        var speed = 750; 
        var offset = page == '#contact' ? 0 : 0;
        var windowWidth = $(window).width();
        
        
        if(windowWidth > 995){
          $('html, body').animate( { scrollTop: $(page).offset().top - 150}, speed ); 
        }else{
          $('html, body').animate( { scrollTop: $(page).offset().top - 100}, speed ); 
        }
        
        return false;
    });
});

  
/* ANIMATE FUNCTION */
window.animateCSS = function animateCSS(element, animationName, callback) {
    var node = document.querySelector(element)
    node.classList.add('animated', animationName)

    function handleAnimationEnd() {
        node.classList.remove('animated', animationName)
        node.removeEventListener('animationend', handleAnimationEnd)

        if (typeof callback === 'function') callback()
    }

    node.addEventListener('animationend', handleAnimationEnd)
}

/* ANIMATED FORM INPUTS*/
window.OnFocusOutForm = function  (event) {
  if(event.target.value.length > 0) {
    event.target.parentElement.classList.add('not-empty');
  }
  else {
    event.target.parentElement.classList.remove('not-empty');
  }
}

/* GMAPS AUTOCOMPLETE*/
var placeSearch, autocomplete;
var componentForm = {
  street_number: 'short_name',
  route: 'long_name',
  locality: 'long_name',
  administrative_area_level_1: 'short_name',
  country: 'long_name',
  postal_code: 'short_name'
};

window.initializeAutocomplete = function (id) {
  if($('#form-modal').hasClass('show')) {
    $('#sticker').remove();
  }
  else {
    $('#form-modal').remove();
  }
  var element = document.getElementById('autocomplete');
  if (element) {
    element.autocomplete = 'new-password';
    autocomplete = new google.maps.places.Autocomplete(element, { types: ['geocode'] });
    autocomplete.setComponentRestrictions({
      'country': 'fr'
    });
    //google.maps.event.addListener(autocomplete, 'place_changed', onPlaceChanged);
  }
  
  document.querySelector('#autocomplete').addEventListener('focusout', function(e) {
        e.target.autocomplete = 'new-password';
  })
  document.querySelector('#autocomplete').addEventListener('keyup', function(e) {
      e.target.autocomplete = 'new-password';
  })
  document.querySelector('#autocomplete').addEventListener('click', function(e) {
      e.target.autocomplete = 'new-password';
  })
  autocomplete.addListener('place_changed', fillInAddress);
}


window.fillInAddress = function () {
  // Get the place details from the autocomplete object.
  document.querySelector('#autocomplete').setAttribute('autocomplete', 'new-password')
  var place = autocomplete.getPlace();
  console.log(place);
  for (var component in componentForm) {
    document.getElementById(component).value = '';
    document.getElementById(component).disabled = false;
  }
  // Get each component of the address from the place details
  // and fill the corresponding field on the form.
  for (var i = 0; i < place.address_components.length; i++) {
    var addressType = place.address_components[i].types[0];
    console.log(addressType)
    if (componentForm[addressType]) {
      var val = place.address_components[i][componentForm[addressType]];
      document.getElementById(addressType).value = val;
    }   
  }
}

/* MENU BUTTON FOR ARTICLES */

function setArticleElms() {
  
}
let stepButton = document.getElementById("step-menu__button");
let stepContent = document.getElementById("step-menu__content");
let stepMenu = document.getElementById("step-menu");
let bannerHeight = document.getElementById("top").clientHeight;
let shadowHeight = document.getElementById("banner");
if(shadowHeight != null) {
  shadowHeight = shadowHeight.clientHeight;
}
let heightOfMenu = bannerHeight + shadowHeight;
let heightScreenAvailablePX = window.innerHeight  + "px";
let heightScreenAvailable = window.innerHeight;
let heighScreen = heightScreenAvailable -50;
let screenForDestkop = document.body.clientWidth > 768;
let textToReplace = "+ Chapitre";
if(stepMenu != null) {
  stepMenu.style.position = 'fixed';
}

///*** MENU OPEN ***/
function stepToogleMenu() {
    if(stepButton != null) {
      stepButton.classList.toggle("active");
      stepMenu.classList.toggle("active");
      if (screenForDestkop && stepContent.style.maxWidth) {
          stepContent.style.maxWidth = null;
          stepButton.innerText = "+";
      } else if (screenForDestkop && !stepContent.style.maxWidth){
          stepContent.style.maxWidth = "330px";
          stepButton.innerText = "-";
      } else if(!screenForDestkop && stepContent.style.maxHeight) {
          stepContent.style.maxHeight = null;
          stepContent.style.height = null;
          stepMenu.style.height = "50px";
          stepMenu.style.bottom = null;
          stepButton.innerText = textToReplace;
      } else{
          stepMenu.style.height = '100%';
          stepContent.style.maxHeight = heightScreenAvailablePX;
          stepContent.style.height = heightScreenAvailablePX;
           stepContent.style.minHeight = '100%';
          stepMenu.style.top = null;
          stepButton.innerText = "- Chapitre";
      }
      
    }
}

///*** FIX MENU POSITION ***/
function changeButtonPosition(){
    if(stepButton != null) {
      let screenIsScrolling = window.scrollY > heightOfMenu;
      if(screenForDestkop && screenIsScrolling){
          stepButton.innerText = "+";
          stepMenu.style.position = "fixed";
          stepMenu.style.top = bannerHeight + 50 + 'px';
      }else if(screenForDestkop && !screenIsScrolling){
          stepButton.innerText = "+";
          stepMenu.style.position = "absolute";
          stepMenu.style.top = 0 + 'px';
      }else if(!screenForDestkop && window.scrollY > 1){
          stepButton.innerText = textToReplace;
          stepMenu.style.bottom = null;
      }else if(!screenForDestkop){
          stepButton.innerText = textToReplace;
          stepMenu.style.bottom = null;
      }
    }
}


window.addEventListener('load', changeButtonPosition);
window.addEventListener('resize', changeButtonPosition);
window.addEventListener('scroll', changeButtonPosition);
if(stepButton != null) {
  stepButton.addEventListener("click",stepToogleMenu);
}

///*** MENU CLOSE ON CLICK ON LINKS ***/
let linksOfMenu = document.querySelectorAll('#step-menu__content > .step-menu__links > a');
for (let i=0; i < linksOfMenu.length; i++) {
    linksOfMenu[i].addEventListener("click",stepToogleMenu);
}


// TOGGLE BACKDROP 
window.toggleBackdrop = function(status) {
    var body = document.querySelector('body');
    
    if(status) {
        body.classList.add('backdrop');
    }
    else {
        body.classList.remove('backdrop');
    }
    
}

// FIND COOKIE BY NAME
function getCookie(c_name) {
    var c_value = document.cookie,
        c_start = c_value.indexOf(" " + c_name + "=");
    if (c_start == -1) c_start = c_value.indexOf(c_name + "=");
    if (c_start == -1) {
        c_value = null;
    } else {
        c_start = c_value.indexOf("=", c_start) + 1;
        var c_end = c_value.indexOf(";", c_start);
        if (c_end == -1) {
            c_end = c_value.length;
        }
        c_value = unescape(c_value.substring(c_start, c_end));
    }
    return c_value;
}
